import LoginReport from '../login-report';
import aegis from '../../../lib/aegis';
import { url } from '@tencent/wphk-base-utils';
import { reportStateCache, getTypeFromCookie, LoginAccessType } from './business';

/** 登陆类型处理类 */
export default class LoginTypeReport {
  business = '';
  loginReport: LoginReport;
  constructor(business: string) {
    this.business = business;
    this.loginReport = new LoginReport(business);
  }

  /** 获取登陆类型 */
  getLoginType() {
    const value = getTypeFromCookie();
    const loginTypeMap: { [key: string]: LoginAccessType } = {
      0: LoginAccessType.auth,
      1: LoginAccessType.minProgram,
      2: LoginAccessType.token,
    };
    let type = loginTypeMap[value];
    // 如果从cookie中没有取到类型，有可能业务还没有接入token方案，这里兜底判断下是否走了auth2登陆
    if (!type && this.loginReport.getLoginReportInfo()) {
      type = LoginAccessType.auth;
    }
    return type;
  }

  /**
     * 上报和登陆相关的首屏渲染速度
     * @param firstScreenTiming  首屏幕渲染时长
     */
  report(firstScreenTiming: number) {
    const loginType = this.getLoginType();
    const loginInfo = this.loginReport.getLoginReportInfo();
    let duration = firstScreenTiming;

    // 页面已经上报过，不再上报，如页面刷新
    if (reportStateCache.checkIsReported()) {
      return;
    }
    // 先存储已上报状态，这里再立即获取存储成功结果，防止sessionStorage存失败了，
    // 不支持sessionStorage时为了防止数据不准确，这类数据不上报
    if (!reportStateCache.saveIsReported()) return;
    switch (loginType) {
      case LoginAccessType.auth:
        // 上报从页面导航进入->auth2登录->页面渲染总耗时
        duration = firstScreenTiming + (loginInfo?.loginDuration || 0);
        if (url.getUrlParam('_stk')) { // 上报token + auth的首屏渲染时长
          aegis.reportTime('bothLoginFirstScreenTiming', duration);
        } else {
          aegis.reportTime('authLoginFirstScreenTiming', duration);
        }
        break;
      case LoginAccessType.token:
        // 上报从页面导航进入->token登录->页面渲染总耗时
        aegis.reportTime('tokenLoginFirstScreenTiming', duration);
        break;
      default:
        // 上报从页面导航进入>页面渲染总耗时
        aegis.reportTime('unLoginFirstScreenTiming', duration);
        break;
    }
  }
}


